import styled from 'styled-components';

export const PeopleDrawerPulseLeadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PeopleDrawerPulseLeadTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  gap: 10px;
`;

export const PeopleDrawerPulseLeadTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const PeopleDrawerPulseLeadTitle = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;

  color: var(--color-text);
`;

export const PeopleDrawerPulseLeadDescription = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;
  white-space: pre-wrap;

  color: var(--color-text);
`;

export const PeopleDrawerPulseLeadLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  min-height: 60px;
`;
